export default __webpack_public_path__ + "static/media/pension_due.f7a4c9f3.svg";